import { RequestHelper } from "../../../../Lib/Helper/RequestHelper";
import { ForeignCurrencyPriceHelper } from "../../../../Lib/Helper/ForeignCurrencyPriceHelper";
import { RentDetailsProdSelectionAbstract } from "./RentDetailsProdSelectionAbstract";
import { RentalProdSelectionTimings } from "../../../../Models/Rental/Details/RentalProdSelectionTimings";
import { RentDetailsSingleItemSelectionSection } from
    "../../../../Models/Rental/Details/RentDetailsSingleItemSelectionSection";

export class RentDetailsProdSelectSingleItemHandler extends RentDetailsProdSelectionAbstract {

    private rentalDetailSingleSelectionItem: RentDetailsSingleItemSelectionSection[] = [];

    constructor(prodSelectionTimings: RentalProdSelectionTimings, pricesPerPersonType: any, foreignCurrencyHelper?: ForeignCurrencyPriceHelper) {
        super(prodSelectionTimings);

        const rentalProductPortlets = document.getElementsByClassName('rental_details__product_portlet');

        for (let i = 0; i < rentalProductPortlets.length; i++) {
            const wrapperElement = rentalProductPortlets[i] as HTMLElement;
            const rentalPackSelection = new RentDetailsSingleItemSelectionSection(wrapperElement, pricesPerPersonType, foreignCurrencyHelper);
            this.rentalDetailSingleSelectionItem.push(rentalPackSelection);
        }
    }

    getSelectionTotalPrice(): number {
        let selectionTotalPrice = 0;

        for (let i = 0; i < this.rentalDetailSingleSelectionItem.length; i++) {
            const selectionComp: RentDetailsSingleItemSelectionSection = this.rentalDetailSingleSelectionItem[i];
            const packPriceTotal = selectionComp.getSectionTotalPrice();
            selectionTotalPrice += packPriceTotal;
        }

        return selectionTotalPrice;
    }

    getAllProductsCount(): number {
        let selectionTotalCount = 0;

        for (let i = 0; i < this.rentalDetailSingleSelectionItem.length; i++) {
            const selectionComp: RentDetailsSingleItemSelectionSection = this.rentalDetailSingleSelectionItem[i];
            selectionTotalCount += selectionComp.getItemsSelectedCount();
        }

        return selectionTotalCount;
    }

    protected createPostData(): any {

        let tempArr = [];

        for (let i = 0; i < this.rentalDetailSingleSelectionItem.length; i++) {
            let tempItem = this.rentalDetailSingleSelectionItem[i];

            if (tempItem.getItemsSelectedCount() < 1) {
                continue;
            }

            const postData = tempItem.getPostData();
            tempArr.push(postData);
        }

        const data = {
            selectedLocationId: this.getSelectedLocationId(),
            startSoapDate: this.prodSelectionTimings.startSoapDate,
            durationIdentifier: this.prodSelectionTimings.durationIdentifier,
            pickupTimeId: this.prodSelectionTimings.pickUpTimeId,
            SelectedItems: tempArr
        };

        return data;
    }

    proceed() {

        const data = this.createPostData();
        const requestHelper = new RequestHelper();
        requestHelper.postToUrl(`/${cultureInfo}/RentalRiderDetails/RiderDetailsSingle`, data, {});

    }
}